import { useReactiveVar } from '@apollo/client';
import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import { MinusIcon } from '@synoptic/ui-kit/icons/react/minus.js';
import { PlusIcon } from '@synoptic/ui-kit/icons/react/plus.js';
import { PositionIcon } from '@synoptic/ui-kit/icons/react/position.js';
import { Separator } from '@synoptic/ui-kit/separator/separator.js';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@synoptic/ui-kit/tooltip/tooltip.js';
import { LayoutCard } from '@/components/layout/card';
import { sigmaInstanceVar } from './sigma-options-var';
import {
  floatingNavigationPanel,
  floatingNavigationPanelButton,
} from '../route.css';

export const SigmaNavigationPanel = () => {
  const sigma = useReactiveVar(sigmaInstanceVar);

  return (
    <LayoutCard className={floatingNavigationPanel}>
      <Tooltip>
        <TooltipTrigger asChild>
          <IconButton
            size="small"
            variant="ghost"
            rounded={false}
            className={floatingNavigationPanelButton}
            onClick={() => sigma && sigma.getCamera().animatedZoom()}
          >
            <PlusIcon />
          </IconButton>
        </TooltipTrigger>
        <TooltipContent side="left" description="Zoom in"></TooltipContent>
      </Tooltip>
      <Separator />
      <Tooltip>
        <TooltipTrigger asChild>
          <IconButton
            size="small"
            variant="ghost"
            rounded={false}
            className={floatingNavigationPanelButton}
            onClick={() => sigma && sigma.getCamera().animatedReset()}
          >
            <PositionIcon />
          </IconButton>
        </TooltipTrigger>
        <TooltipContent side="left" description="Reset zoom"></TooltipContent>
      </Tooltip>
      <Separator />

      <Tooltip>
        <TooltipTrigger asChild>
          <IconButton
            size="small"
            variant="ghost"
            rounded={false}
            className={floatingNavigationPanelButton}
            onClick={() => sigma && sigma.getCamera().animatedUnzoom()}
          >
            <MinusIcon />
          </IconButton>
        </TooltipTrigger>
        <TooltipContent side="left" description="Zoom out"></TooltipContent>
      </Tooltip>
    </LayoutCard>
  );
};
